<template>
    <div
        class="header"
        :class="{'header__fixed-navbar' : layout, 'header__full-height-mobile': styles.full_height_mobile}"
        :style="uploadOption"
    >
        <div class="container h-100 d-flex flex-wrap justify-content-center align-items-center">
            <div class="col-12">
                <h1
                    class="header__title mb-4"
                    :class="`text-${styles.title.align}`"
                    :style="{ color: styles.title.color }"
                >{{translation.title}}</h1>
                <p
                    v-if="translation.description"
                    class="header__description"
                    :class="`text-${styles.description.align}`"
                    :style="{ color: styles.description.color }"
                >{{translation.description}}</p>
            </div>

            <div class="col-12 arrows-column" v-if="total > 1 && index == 0">
                <svg class="arrows" :style="{stroke: styles.title.color}">
                    <path class="a1" d="M0 0 L30 32 L60 0"></path>
                    <path class="a2" d="M0 20 L30 52 L60 20"></path>
                    <path class="a3" d="M0 40 L30 72 L60 40"></path>
                </svg>
            </div>
        </div>
    </div>
</template>
 
<script>
import image from "../../mixins/image";

import BaseButton from "../../argon/components/BaseButton";
export default {
    name: "Header",
    mixins: [image],
    components: {
        BaseButton
    },
    props: {
        content: {
            type: Object,
            required: true
        },
        total: {
            type: Number,
            description: 'Total de componentes exibidos na home'
        },
        index: Number
    },
    data() {
        return {
            src: "",
            styles: this.content.styles,
            translation: this.content.translation
        };
    },
    computed: {
        layout() {
            return this.$store.getters.NAVBAR_FIXED;
        },
        uploadOption() {
            if (this.styles.body.type === 1) {
                return {
                    backgroundColor: this.styles.body.background_color
                };
            } else {
                return {
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundAttachment: this.styles.body.fixed ? 'fixed' : null,
                    backgroundImage: `url(${this.image(this.content.upload)})`
                };
            }
        }
    }
};
</script>

<style lang="scss" scoped>

.arrows {
	width: 60px;
	height: 72px;
}

.arrows path {
	fill: transparent;
	stroke-width: 1px;	
	animation: arrow 2s infinite;
	-webkit-animation: arrow 2s infinite; 
}

@keyframes arrow
{
    0% {opacity:0}
    40% {opacity:1}
    80% {opacity:0}
    100% {opacity:0}
}

@-webkit-keyframes arrow /*Safari and Chrome*/
{
    0% {opacity:0}
    40% {opacity:1}
    80% {opacity:0}
    100% {opacity:0}
}

.arrows path.a1 {
	animation-delay:-1s;
	-webkit-animation-delay:-1s; /* Safari 和 Chrome */
}

.arrows path.a2 {
	animation-delay:-0.5s;
	-webkit-animation-delay:-0.5s; /* Safari 和 Chrome */
}

.arrows path.a3 {	
	animation-delay:0s;
	-webkit-animation-delay:0s; /* Safari 和 Chrome */
}

$screen-xs: 360px;
$screen-sm: 450px;
$screen-md: 1028px;

.arrows-column {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: absolute;
    bottom: 50px;
        @media screen and (max-width: $screen-md) {
            bottom: 30px;
            transform: scale(.8);
        }

        @media screen and (max-width: $screen-sm) {
            bottom: 0;
            transform: scale(.6);
        }
}

.header:before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    background: inherit;
}

.header {
    width: 100%;
    background-position: center;
    z-index: 1;
    height: 56.25vw;
    max-height: 1080px;
    
    @media screen and (max-width: $screen-md) {
        background-attachment: unset !important
    }

    &__full-height-mobile {
        @media screen and (max-width: $screen-md) {
            height: 100vh;
        }
    }
    &__title {
        text-transform: uppercase;
        z-index: 2;
        font-size: 3rem;
        text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);

        @media screen and (max-width: $screen-md) {
            margin-top: 6rem;
        }

        @media screen and (max-width: $screen-sm) {
            font-size: 1.7rem;
            margin-top: 3rem;
        }

        @media screen and (max-width: $screen-xs) {
            font-size: 1.3rem;
            margin-top: 1.2rem;
        }
    }

    &__description {
        font-size: 1.4rem;
        z-index: 2;

        @media screen and (max-width: $screen-md) {
            font-size: 1.1rem;
            margin: 0 15px;
            text-align: justify;
        }

        @media screen and (max-width: $screen-sm) {
            font-size: 1rem;
            margin: 0 15px;
            text-align: justify;
        }

        @media screen and (max-width: $screen-xs) {
            font-size: 0.8rem;
            margin: 1rem;
            text-align: justify;
        }
    }
}
</style>
